import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Seaport() {
  return (
    <ImageCollectionPage 
      title="Seaport" 
      path="/seaport" 
      collection="seaport" 
    />
  );
}
